<template>
  <div>
    <download-excel
      :fields="json_fields"
      :fetch="startDownload"
      type="xls"
      name="积分余额表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
    <span style="margin-left: 20px;">
      当前商户用户剩余积分合计：{{ sumIntegral }} 
    </span>
     <a-table 
      :columns="columns" 
      :data-source="data" 
      :loading="loading"
      :pagination="pagination"
      :row-key="(record) => record.objId"
      @change="handleTableChange">


  </a-table>
  </div>
</template>
<script>
import { userIntergralDetail ,userIntergralTotal} from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  // {
  //   title: "id",
  //   dataIndex: "objId",
  //   align: "center",
  //   key: "1",
  //   width:100,
  // },
  {
    title: "用户id",
    dataIndex: "userUid",
    align: "center",
    key: "2",
  
  },
  {
    title: "手机号码",
    dataIndex: "phone",
    align: "center",
    key: "2",
  
  },

  {
    title: "积分余额",
    dataIndex: "balance",
    align: "center",
    key: "3",

  },
   {
    title: "累计加积分",
    dataIndex: "totalIncome",
    align: "center",
    key: "3",

  },

    {
    title: "累计扣积分",
    dataIndex: "totalExpend",
    key: "4",
    align: "center",
  },

  {
    title: "注册时间",
    dataIndex: "createTime",
    align: "center",
    key: "6",

  },


];


export default {
  data() {
    return {
      data: [],
      json_fields: {
        订单号: "orderNo",
        用户id: "userUid",
        手机号码:"phone",
        积分余额: "balance",
        累计加积分:"totalIncome",
        累计扣积分:"totalExpend",
        注册时间: "createTime",
        
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      localFormInline: {} ,// 新增：用于存储 formInline 的本地副本
      sumIntegral: 0,
    };
  },
  mounted() {
    // 刚点开的时候自动加载全部数据
    this.getOrderList();
    this.getByMerchants();
  },
  props: ["formInline"],
  watch: {
    // 监听 formInline 变化并更新本地副本
    formInline: {
      handler(newVal) {
        this.localFormInline = { ...newVal };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    // 查询
    search() {
     
      // 创建一个新的对象，清空 createTime 字段
      const queryParams = {
        ...this.localFormInline,
        createTime: null,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      // console.log('数据:', queryParams);
      
      this.data = [];
      this.loading = true;
 
      userIntergralDetail(queryParams).then((res) => {
        console.log('请求成功，返回数据:', res);
        this.loading = false;
        if(res.data !=null){
          this.data = res.data;
          this.pagination.total = Number(res.count);

        }else{
          message.error('暂无数据');
        }
        
        
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('error', error);
      });
    },
      // 添加这个方法用于导出所有数据
    async startDownload() {
      try {
        // 调用API获取所有数据，不分页
        const res = await userIntergralDetail({
          page: 1,
          limit: 10000 // 设置一个足够大的数值来获取所有数据
        });
        
        if (res.data != null) {
          // 返回所有数据用于导出
          return res.data;
        } else {
          message.error('暂无数据可导出');
          return [];
        }
      } catch (error) {
        message.error('导出失败: ' + error.message);
        return [];
      }
    },
    // 分页按钮配置
    handleTableChange(pagination, filters, sorter) {
      console.log('分页变化:', pagination);
      this.pagination.current = pagination.current; //重置当前页
      this.pagination.pageSize = pagination.pageSize; //重置每页条数
      this.search(); //重新查询
    },
    // 分页数据
    getOrderList() {
      this.data = [];
      // 重置分页参数并查询第一页
      this.pagination.current = 1;
    
      userIntergralDetail({
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        userUid:this.formInline.userUid,
        phone:this.formInline.phone,
        startTime:this.formInline.startTime,
        endTime:this.formInline.endTime,
      }).then((res) => {
        console.log('userIntergralList:', res);
        if(res.data !=null){
          this.pagination.total = Number(res.count);
          this.data = res.data;
        }else{
          message.error('暂无数据');
        }

      }).catch((error) => {
        console.error('请求出错:', error);
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },

    getByMerchants() { 
      userIntergralTotal().then((res) => {
        console.log('userIntergralTotal:', res);
        if(res.data !=null || res.data.length > 0){
          this.sumIntegral = res.data[0].balance;
        }
      }).catch((error) => {
        console.error('请求出错:', error);
      });
    },
   

  },
};
</script>
<style scoped>
.test {
  position: relative;
  left: 55px;
}

#components-table-demo-summary tfoot th,
#components-table-demo-summary tfoot td {
  background: #fafafa;
}
[data-theme='dark'] #components-table-demo-summary tfoot th,
[data-theme='dark'] #components-table-demo-summary tfoot td {
  background: #1d1d1d;
}
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/intergralOrder/intergralBalanceContent.vue